import React, { useEffect, useState } from 'react';
import {Button, Pagination, Popconfirm, Modal, Form, Input, Switch, Select, message  , InputNumber} from 'antd';

import Breadcrumbs from '../../../common/breadcrumb/Breadcrumbs';
import Loader from '../../../common/loader/Loader';
import { getAllAvaiableBankList, getBonusBankAccount, usersListForResellerPartnerApiUser, getBonusTxnAmount, getBonusTxnCap, getBonusSetting, deleteBonusSetting, addBonusSetting, updateBonusSetting } from '../../../api/login/Login';

const { Option } = Select;



const breadCrumbsTitle = {
    id: '1',
    title_1: 'Bonus Tranaction Master',
    path_1: '/admin/bonus-transaction-settings',
    title_2: 'Bonus Transaction Settings',
  };



const BonusTransactionSetting = () => {
      const [loading, setLoading] = useState(false);
        const [data, setData] = useState([]);
        const [pageNo, setPageNo] = useState(1); 
        const [totalData, setTotalData] = useState(0); 
        const [limit , setLimit] = useState(10); 
        const [resetKey, setResetKey] = useState(false); 
        const [allBank , setAllBank] = useState([])
        const [allUser , setAlluser] = useState([])
        const [allTransactionCap , setAllTransactionCap] = useState([])
        const [allTransactionAmount , setAllTransactionAmount] = useState([])
       
        const [isModalVisible, setIsModalVisible] = useState(false);
        const [currentItem, setCurrentItem] = useState(null);
        const [form] = Form.useForm();
      useEffect(() => {
  const fetchAllDropdownData = async () => {
    setLoading(true);
    try {
      const [bankRes, amountRes, capRes, userRes] = await Promise.all([
        getBonusBankAccount(),
        getBonusTxnAmount(),
        getBonusTxnCap(),
        usersListForResellerPartnerApiUser(),
      ]);

      console.log(bankRes?.data)

      setAllBank(bankRes?.data || []);
      setAllTransactionAmount(amountRes?.data || []);
      setAllTransactionCap(capRes?.data || []);
      setAlluser(userRes?.data || []);
    } catch (error) {
      console.error("Failed to fetch dropdown data", error);
      message.error("Failed to load form data.");
    } finally {
      setLoading(false);
    }
  };

  fetchAllDropdownData();
}, []);

        
  const handleAdd = () => {
    setCurrentItem(null);
    form.resetFields();
    setIsModalVisible(true);
  };


   const handleOk = async () => {
     try {
       // will resolve only if every rule passes
       const values = await form.validateFields();
       console.log('✅ Valid form data:', values);
         const transformedData = {
       ...values,
       status: values.status ? 'Active' : 'Inactive',
     };

      console.log('✅ Valid form data:', transformedData);
       let res 
       
 
         if (currentItem) {
               // Update
                res  =await updateBonusSetting({
  id: currentItem._id,
  data: transformedData,
});
              
             } else {
               // Add new
               res = await addBonusSetting(transformedData)
             }
 
             if(res?.error === false)
                 {
                  setIsModalVisible(false);
                  message.success(res?.message);
                  setResetKey(prev => !prev); 
                 }
                 else {
                  message.error(res?.message);
                 }    
   
       // ...continue (API call, close modal, etc.)
     } catch (errorInfo) {
       // errorInfo = { values, errorFields, outOfDate }
       console.log('❌ Validation failed:', errorInfo);
   
       // If you want to scroll to first error:
       // form.scrollToField(errorInfo.errorFields[0].name);
     } finally {
       setLoading(false);
     }
   };
   
 
     const handleDelete = async (id) => {
       setLoading(true);
       // deleteTransactionType()
       try {
        let res  =  await deleteBonusSetting(id)
        if(res?.error === false)
         {
          message.success(res?.message);
          setResetKey(prev => !prev); 
         }
         else {
          message.error(res?.message);
         }
      
         
       } catch (error) {
        
       }
       setLoading(false);
     };
 
 
     // ✅ Fetch data function
     const fetchData = async () => {
       let body = {
         page:pageNo,
         limit:limit
       }
       // setLoading(true);
       try {
         const response = await getBonusSetting(body)
         console.log(response)
         setData(response.data || []);
         setTotalData(response.data.length || 0); // ✅ update total count
       } catch (error) {
         // message.error('Failed to fetch data');
       }
       // setLoading(false);
     };
   
     // ✅ On mount & when resetKey OR pageNo changes
     useEffect(() => {
       fetchData();
     }, [resetKey, pageNo]);


     const handleEdit = (item) => {
  setCurrentItem(item);
  form.setFieldsValue({
    ...item,
    status: item.status === 'Active', // convert "Active"/"Inactive" to boolean
  });
  setIsModalVisible(true);
};

  // const handleBankChange = (value) => {
  //   console.log(value , "value")
  //   const selectedBank = allBank.find((bank) => bank._id === value);
  //   if (selectedBank) {
  //     form.setFieldsValue({ ifsc_code: selectedBank.ifsc_code });
  //   }
  // };
  
  return (
    <>
      <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
          {loading && <Loader />}
           <div className="row m-4">
                  <div className="col-xl-12">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                          <div className="tbl-caption d-flex justify-content-between align-items-center">
                            <h4 className="heading mb-0">Transaction Setting List</h4>
                            {/* <button type="button" className="btn btn-secondary btn-sm" onClick={handleAdd}>
                              Add Transaction Type
                            </button> */}
                            <Button type="primary" size="small" onClick={handleAdd}>
                            + Add New Transaction Setting
                          </Button>
                          </div>
                          <table className="table">
                         <thead>
  <tr>
    <th>Name</th>
    <th>Bank</th>
    <th>Bonus Cap</th>
    <th>Bonus Amount</th>
    <th>User</th>
    <th>Status</th>
    <th>Action</th>
  </tr>
</thead>

                            <tbody>
                              {data?.length > 0 ? (
                                data?.map((item) => (
                                
                                    <tr key={item._id}>
  <td>{item.name}</td>
  <td>
    {
      allBank?.find(bank => bank._id === item.bank_id)?.bank_name || 'N/A'
    }
  </td>
  <td>
    {
      allTransactionCap?.find(cap => cap._id === item.bonus_cap_id)?.cap || 'N/A'
    }
  </td>
  <td>
    {
      allTransactionAmount?.find(amount => amount._id === item.bonus_amount_id)?.amount || 'N/A'
    }
  </td>
  <td>
    {
      allUser?.find(user => user._id === item.user_id)?.name || 'N/A'
    }
  </td>
  <td>
    <span className={`badge ${item.status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
      {item.status}
    </span>
  </td>
  <td>
    <div className="d-flex">
      <button onClick={() => handleEdit(item)} className="btn btn-primary btn-xs sharp me-2">
        <i className="fa fa-pencil" />
      </button>
      <Popconfirm
        title="Delete transaction Setting?"
        onConfirm={() => handleDelete(item._id)}
        okText="Yes"
        cancelText="No"
      >
        <button className="btn btn-danger btn-xs sharp">
          <i className="fa fa-trash" />
        </button>
      </Popconfirm>
    </div>
  </td>
</tr>

                                
                                
                                
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="3" className="text-center">
                                    No data found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          <div className="d-flex justify-content-between align-items-center p-2">
                            <div>Total {totalData} entries</div>
                            <Pagination
                              current={pageNo}
                              total={totalData}
                              pageSize={limit}
                              onChange={(page) => setPageNo(page)} // ✅ update pageNo state
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

           <Modal
                  title={currentItem ? 'Update Setting' : 'Add New Setting'}
                  open={isModalVisible}
                  onOk={handleOk}
                  onCancel={() => setIsModalVisible(false)}
                  okText={currentItem ? 'Update' : 'Add'}
                   className="add-bank-modal"
                >
                  <Form form={form} layout="vertical">
   <Form.Item
        name="name"
        label="Name"
        rules={[
          { required: true, message: 'Please enter name' },
         
        ]}
      >
        <Input placeholder="Name" />
      </Form.Item>

                  
                    
     <Form.Item
        name="bank_id"
        label="Bank Name"
        rules={[{ required: true, message: 'Please select a bank' }]}
        validateTrigger={['onBlur', 'onChange']}
      >
        <Select
          showSearch
          placeholder="Search and select a bank"
          optionFilterProp="children"
         
          // onChange={handleBankChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {allBank?.map((bank) => (
            <Option key={bank._id} value={bank._id}>
              {bank.bank_name}
            </Option>
          ))}
        </Select>
      </Form.Item>

       <Form.Item
        name="bonus_cap_id"
        label="Bonus Transaction Cap"
        rules={[{ required: true, message: 'Please select a cap' }]}
        validateTrigger={['onBlur', 'onChange']}
      >
        <Select
          showSearch
          placeholder="Search and select a transaction cap"
          optionFilterProp="children"
         
          // onChange={handleBankChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {allTransactionCap?.map((value) => (
            <Option key={value._id} value={value._id}>
              {value.cap}
            </Option>
          ))}
        </Select>
      </Form.Item>

       <Form.Item
        name="bonus_amount_id"
         label="Bonus Transaction Amount"
        rules={[{ required: true, message: 'Please select a transaction amount' }]}
        validateTrigger={['onBlur', 'onChange']}
      >
        <Select
          showSearch
          placeholder="Search and select a transaction amount"
          optionFilterProp="children"
         
          // onChange={handleBankChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {allTransactionAmount?.map((bank) => (
            <Option key={bank._id} value={bank._id}>
              {bank.amount}
            </Option>
          ))}
        </Select>
      </Form.Item>

       <Form.Item
        name="user_id"
        label="User"
        rules={[{ required: true, message: 'Please select a user' }]}
        validateTrigger={['onBlur', 'onChange']}
      >
        <Select
          showSearch
          placeholder="Search and select a user"
          optionFilterProp="children"
         
          // onChange={handleBankChange}
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {allUser?.map((bank) => (
            <Option key={bank._id} value={bank._id}>
              {bank.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

    


                    <Form.Item
            name="status"
            label="Status"
            valuePropName="checked"
            style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}
          >
            <Switch
              checkedChildren="Active"
              unCheckedChildren="Inactive"
              className="custom-switch"
            />
          </Form.Item>
          
                  </Form>
                </Modal>      
    
    </>
  )
}

export default BonusTransactionSetting

